/** Pied d’app — même formule que FacturX / Chat / le hub. */
export function AureliaCopyright() {
  const year = new Date().getFullYear();
  return (
    <footer className="sg-copyright">
      <p>
        © {year}{" "}
        <a href="https://aureliasuite.fr" target="_blank" rel="noopener noreferrer">
          Aurélia Suite
        </a>
        . Tous droits réservés
        <span className="sg-copyright__sep" aria-hidden>
          •
        </span>
        Conforme RGPD
        <span className="sg-copyright__sep" aria-hidden>
          •
        </span>
        Studio Seth — Pacy-sur-Eure (27)
      </p>
    </footer>
  );
}
